<script>
import ModelIndex from "../models/index"

export default {
  extends: ModelIndex,
  page: {
    title: "JALA Farms",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_farms.plural')) }},
    resourceRoute: {default: 'jala_farms'},
    modelVariable: {default: 'jala_farm'}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_farms.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('jala_farms.plural')),
          href: "/jala_farms",
          active: true,
        },
      ],
      filterColumns: {
        name: { type: String, label: this.lodash.upperFirst(this.$t('jala_farms.name')) },
      }
    }
  },
  computed: {
    columns() {
      return {
        ['jala_farm']: [
          { key: 'index', label: '#', sortable: false, style: { width: '1%' } },
          {
            key: 'name',
            label: this.lodash.upperFirst(this.$t('jala_farms.name')),
            thStyle: { minWidth: '200px' },
            sortable: true,
            component: {
              props: ['item'],
              template: '<div style="width: 200px" class="text-truncate" :title="item.name">' +
                  '<a :href="`http://jala-trade.jala.test/home?farm_id=` + item.id" target="_blank">{{ item.name }}</a>' +
                  '</div>'
            }
          },
          {
            key: 'region',
            label: this.lodash.upperFirst(this.$t('jala_farms.region')),
            thStyle: { minWidth: '400px' },
            sortable: false,
            component: {
              props: ['item'],
              template: '<span style="white-space: pre">{{ (item.region || {}).full_name }}</span>'
            }
          },
          { key: 'action', class: 'text-center', style: { width: '1%' } }
        ],
      };
    },
  },
  methods: {
    delete(value) {
      if (value['investor_farm'])
        return this.$axios.delete(`/jala/investor_farms/${value['investor_farm'].id}`)
      return this.$axios.delete(`/jala/farms/${this.getModelKey(value)}`)
    },
    fetchModels(page = 1) {
      return this.$axios.get('/jala/farms', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          with: 'region,investor_farm,farm_users',
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta } } = response;
        this.models = data.map((datum) => ({
          ...datum,
          _denyShow: false,
          _denyEdit: false,
          _denyDelete: false
        }))
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        return response;
      }).catch((error) => this.failedAlert(error));
    }
  },
};
</script>
